module.exports = __webpack_public_path__ + "static/media/IMG_2369.4848ccb6.JPG";